import React from 'react';
import { useTranslation } from 'next-i18next';
import Dialog from 'src/components/Dialog';
import DialogButton from 'src/components/DialogButton';
import { useIdleTimer } from 'src/hooks/useIdleTimer';
import { LogoutPhase, useLogoutState } from '../providers/LogoutKindProvider';
import * as S from './IdleTimerDialog.styles';
const IdleTimerDialog = () => {
  const {
    t
  } = useTranslation();
  const {
    setState,
    state
  } = useLogoutState();
  const idleTimer = useIdleTimer({
    onPrompt: () => {
      setState(LogoutPhase.ABOUT_TO_LOGOUT);
    }
  });
  const handleStayLoggedIn = () => {
    setState(null);
    idleTimer.activate();
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    open: state === LogoutPhase.ABOUT_TO_LOGOUT,
    icon: /*#__PURE__*/React.createElement(S.TimeIcon, null),
    title: t('b2b.idle_dialog.heading'),
    actions: /*#__PURE__*/React.createElement(DialogButton, null, t('b2b.idle_dialog.stayLoggedIn')),
    onClickInside: handleStayLoggedIn,
    onClose: handleStayLoggedIn
  }, t('b2b.idle_dialog.subheading'));
};
export default IdleTimerDialog;